
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brand/[symbol]",
      function () {
        return require("private-next-pages/brand/[symbol].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brand/[symbol]"])
      });
    }
  